import { singleton } from "tsyringe";
import OpenGraphMetadataResponseResource from "common/resources/OpenGraph/OpenGraphMetadataResponseResource";
import BaseApi from "../BaseApi";

@singleton()
export default class HtmlContentApi extends BaseApi {
	private baseurl = `${this.apiUrl}/open-graph`;

	public async getMetadata(url: string) {
		const encodedUrl = encodeURIComponent(url);
		const requestUrl = `${this.baseurl}/metadata?url=${encodedUrl}`;

		return this.getRequest<OpenGraphMetadataResponseResource>(requestUrl);
	}
}
